import React from 'react';
import ContactHero from '../components/Contact/ContactHero';
import ContactInformation from '../components/Contact/ContactInformation';
import ExistingClients from '../components/Contact/ExistingClients';
import FAQSection from '../components/Contact/FAQSection';

const Contact = () => {
  return (
    <div>
      <ContactHero />
      <ContactInformation />
      <ExistingClients />
      <FAQSection />
    </div>
  );
};

export default Contact;
